import { Box, Typography } from '@mui/material';
import { useState, useCallback } from 'react';

// Our Components
import PageHeading from 'components/PageHeading/PageHeading';
import KeyActionTabs from 'components/Tabs/KeyActionTabs/KeyActionTabs';
import Tooltip from 'components/Tooltip';

const KEY_ACTION_TAB_MAPPING = {
	0: 'REVIEW',
	1: 'SENT',
	2: 'ARCHIVED'
};

const KEY_ACTION_DESCRPTION = {
	REVIEW: 'These are the available key actions that can be sent to advisors.',
	SENT: 'These are the key actions that have been sent to advisors.',
	ARCHIVED: 'These are the key actions that have been archived.'
};

function KeyActionsPage() {
	// Tab State
	const [tabPanelSelected, setTabPanelSelected] = useState(0);

	const handleTabSelection = useCallback((_, value) => {
		setTabPanelSelected(value);
	}, []);

	const selectedTab = KEY_ACTION_TAB_MAPPING[tabPanelSelected];
	const selectedTabDescription = KEY_ACTION_DESCRPTION[selectedTab];

	return (
		<>
			<PageHeading
				title="Key Actions"
				subtitleText={
					<Box
						sx={{
							display: 'flex',
							gap: 1,
							paddingTop: 1,
							paddingBottom: 1
						}}
					>
						<Typography variant="body2">
							{selectedTabDescription}
						</Typography>
						{selectedTab === 'REVIEW' && (
							<Tooltip text="Select a key action row below to send a key action email to the advisor." />
						)}
					</Box>
				}
			/>

			<KeyActionTabs
				tabPanelSelected={tabPanelSelected}
				handleTabSelection={handleTabSelection}
			/>
		</>
	);
}

export default KeyActionsPage;
